<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 17.162 13.868"
  >
    <g transform="translate(-0.25 0.061)">
      <path
        d="M1,6.873H16.662M10.789,1l5.873,5.873-5.873,5.873"
        fill="none"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
        fill-rule="evenodd"
      />
    </g>
  </svg>
</template>
